import React, { useCallback } from 'react'

import { useTranslation } from 'react-i18next'
import { GetProps, Input } from 'antd'
import { useSelector } from 'react-redux'
import { useAction } from '@agro-club/frontend-shared'
import CompanySelectors from '../../../../../modules/domain/company/selectors'
import CompanyActions from '../../../../../modules/domain/company/duck'

const { Search } = Input
type SearchProps = GetProps<typeof Input.Search>

type CompanySearchInputFilterProps = SearchProps & {
  excludeCompanyIds: string[]
}

const CompanySearchInputFilter: React.FC<CompanySearchInputFilterProps> = ({ excludeCompanyIds, ...restProps }) => {
  const { t } = useTranslation('company')
  const companyFilter = useSelector(CompanySelectors.listByExcludedIdsFilter)
  const companyFilterUpdate = useAction(CompanyActions.listByExcludedIdsFilterUpdated)
  const handleSearchChange = useCallback(
    (search?: string) => {
      companyFilterUpdate({ filters: { ...companyFilter, search }, exclude_companies: excludeCompanyIds })
    },
    [companyFilter, companyFilterUpdate, excludeCompanyIds],
  )

  const onSearch: SearchProps['onSearch'] = (value, _e, _info) => {
    handleSearchChange(value)
  }

  return <Search {...restProps} placeholder={t('component.input.placeholder')} onSearch={onSearch} />
}

export default CompanySearchInputFilter
